// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"e1-z"};